<div class="top">
    <div class="header">
        <h1 align="center">Prohibited Items</h1>
    </div>
    <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
    </div>
    <div class="header1">
        <!-- <h5>Prohibited Items</h5> -->
        <h4 style="margin-top: 30px;margin-bottom:50px;font-size: 1.5rem;">Before Buying Items, Please Check With Us. Not All Items Are
            Eligible For Import In Each Country. Restrictions Apply, Hence Please Check With Us.</h4>
        <h4>Restricted & Banned Items</h4>
        <p style="font-size: 1rem;">Passport, Currency Notes & Coins, Uncrossed(bearer cheques) drafts/cheques, Precious stones, Jewelry, Arms &
            ammunition, Dry ice, Firearms, explosives, military equipment, Flammable adhesives, Infectious substances,
            Magnetized materials.</p>
        <ul type="disc" style="margin-top: 50px;margin-bottom: 60px;" class="ul_li">
            <li>Non veg Items</li>
            <li>Dairy Items</li>
            <li>Oils</li>
            <li>Flammable items</li>
            <li>Raw or perishable items</li>
            <li>Liquid, semi-liquid and gases</li>
            <li>Perfumes containing alcohol</li>
            <li>Currency</li>
            <li>Indian Postal Articles and all items that infringe the Indian Postal Act of 1898</li>
            <li>Precious and semi-precious stones, gems, jewelry and equivalent items</li>
            <li>Perishables</li>
            <li>Radioactive or magnetic material</li>
            <li>Negotiable Instruments (Bearer Form)</li>
            <li>Pornographic material</li>
            <li>Sodexo pass</li>
            <li>Firearms, explosives and military equipment</li>
            <li>Flammable Items</li>
            <li>Toxic and infectious Items</li>
            <li>Corrosives</li>
            <li>Powders and chemicals</li>
            <li>Drugs</li>
            <li>Machinery parts containing oil, grease, fuel or batteries</li>
            <li>All restricted items as per guidelines of IATA</li>
        </ul>
        <h5>Dangerous Goods</h5>
        <p style="font-size: 1rem;">Definition: Commodities, which possess potentially hazardous characteristics. These are as the laid out
            by IATA in the Dangerous Goods Regulations. The categories of dangerous goods are:</p>
        <ul type="disc" class="dang_ul_li">
            <li>Acidic</li>
            <li>Caustic</li>
            <li>Combustible Communicable</li>
            <li>Compressed Gas</li>
            <li>Corrosive</li>
            <li>Explosive</li>
            <li>Flammable</li>
            <li>Infectious</li>
            <li>Inflammable</li>
            <li>Poison</li>
            <li>Radioactive</li>
            <li>Refrigerated</li>
            <li>Toxic</li>
            <li>Volatile</li>
        </ul>
        <p style="font-size: 1rem; margin-bottom: 50px;">Additional information on prohibited and restricted items can be retrieved by customs in local country and by
            Indian government. Customer is responsible for confirming that prohibited and restricted items are not sent
            to yourDesiCart.com’s facility. Customer must be held responsible for any software and/or date residing on
            used electronic equipment and must comply with import and export laws and government regulations in India.
            yourDesiCart.com will not responsible for the loss of any software and/or data.</p>
    </div>

    <app-footer></app-footer>
</div>